import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss'] 
})
export class AlertBoxComponent implements OnInit {
  constructor( private elRef: ElementRef,public dialogRef: MatDialogRef<AlertBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    }
  onClose(response: boolean) {
    this.dialogRef.close(response);
  }
  ngOnInit(): void {
    let the = localStorage.getItem('theme')
    // if(the.length <= 0){
    //   this.theme('blue')
    // }else{
    //   this.theme(the);
    // }
  }

  // theme(i){
  //   if(i== 'white'){
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-one','gray');
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#aaaaaa');
  //     this.elRef.nativeElement.style.setProperty('--primary-bg-color','gray');
  //     this.elRef.nativeElement.style.setProperty('--dark-border','gray');
  //     this.elRef.nativeElement.style.setProperty('--main-content-title','gray');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','black');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','black');
  //     this.elRef.nativeElement.style.setProperty('--side-sub-link','white');
  //     localStorage.setItem("theme",i)
  //   }else if(i== 'yellow'){
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-one','#ffab00');
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#efb960');
  //     this.elRef.nativeElement.style.setProperty('--primary-bg-color','#ffab00');
  //     this.elRef.nativeElement.style.setProperty('--dark-border','#ffab00');
  //     this.elRef.nativeElement.style.setProperty('--main-content-title','#ffab00');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','#ffb10f');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','#f0d6a1');
  //     this.elRef.nativeElement.style.setProperty('--side-sub-link','white');
  //     localStorage.setItem("theme",i)
  //   }else if(i== 'red'){
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-one','#ff4a42');
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#ef8d89');
  //     this.elRef.nativeElement.style.setProperty('--primary-bg-color','#ff4a42');
  //     this.elRef.nativeElement.style.setProperty('--dark-border','#ff4a42');
  //     this.elRef.nativeElement.style.setProperty('--main-content-title','#ff4a42');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','#ff4a42');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','#ff4a42');
  //     this.elRef.nativeElement.style.setProperty('--side-sub-link','white');
  //     localStorage.setItem("theme",i)
  //   }else if(i== 'green'){
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-one','green');
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#85b87f');
  //     this.elRef.nativeElement.style.setProperty('--primary-bg-color','green');
  //     this.elRef.nativeElement.style.setProperty('--dark-border','green');
  //     this.elRef.nativeElement.style.setProperty('--main-content-title','green');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','green');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','green');
  //     this.elRef.nativeElement.style.setProperty('--side-sub-link','white');
  //     localStorage.setItem("theme",i)
  //   }else if(i == 'sky_blue'){
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-one','#03a2e2');
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#96d1f1'); 
  //     this.elRef.nativeElement.style.setProperty('--primary-bg-color','#03a2e2');
  //     this.elRef.nativeElement.style.setProperty('--dark-border','#03a2e2');
  //     this.elRef.nativeElement.style.setProperty('--main-content-title','#03a2e2');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','#03a2e2');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','#03a2e2');
  //     this.elRef.nativeElement.style.setProperty('--side-sub-link','white');
  //     localStorage.setItem("theme",i)
  //   }else{
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-one','#f0f5ff');
  //     this.elRef.nativeElement.style.setProperty('--primary-gradent-two','#f0f5ff');
  //     this.elRef.nativeElement.style.setProperty('--primary-bg-color','#f0f5ff');
  //     this.elRef.nativeElement.style.setProperty('--dark-border','#f0f5ff');
  //     this.elRef.nativeElement.style.setProperty('--main-content-title','#f0f5ff');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-1','#7787bc');
  //     this.elRef.nativeElement.style.setProperty('--breadcrumb-lable-2','#8f9cc0');
  //     this.elRef.nativeElement.style.setProperty('--side-sub-link','#c7c7c7');
  //     localStorage.setItem("theme",i)
  //   }
  //  }
}
